import React, { useLayoutEffect, useRef } from "react";
import Button from "../../atoms/Button/Button";
import styles from "./ToolTipGuideLine.module.scss";

const ToolTipCard = ({
  title,
  content,
  next,
  position,
  arrowPosition,
  arrowAlignment,
  alignment,
  handleNext,
  handleOk,
  targetComponent,
  toolTips,
  currentStep,
}) => {
  const ref = useRef(null);
  const {
    top,
    left,
    width: targetCompWidth,
    height: targetCompHeight,
  } = targetComponent.getBoundingClientRect();

  const getArrowStyles = () => {
    if (
      ["top", "bottom"].includes(arrowPosition) &&
      arrowAlignment === "center"
    ) {
      return {
        [arrowPosition]: -12,
        left: 165,
      };
    } else if (
      ["left", "right"].includes(arrowPosition) &&
      arrowAlignment === "center"
    ) {
      return {
        [arrowPosition]: -12,
        top: 60,
      };
    }
    return {
      [arrowPosition]: -12,
      [arrowAlignment]: 20,
    };
  };

  useLayoutEffect(() => {
    const { height: toolTipHeight, width: toolTipWidth } =
      ref.current.getBoundingClientRect();
    if (position === "top" || position === "bottom") {
      if (alignment === "center") {
        ref.current.style.left = left - 40 + targetCompWidth / 2 + "px";
      } else if (alignment === "right") {
        ref.current.style.left = left - (360 - targetCompWidth) + "px";
      } else {
        ref.current.style.left = left + "px";
      }
      ref.current.style.top =
        position === "top"
          ? top - toolTipHeight - 18 + "px"
          : top + targetCompHeight + 20 + "px";
    } else if (position === "left" || position === "right") {
      ref.current.style.top = top + "px";
      ref.current.style.left =
        position === "left"
          ? left - toolTipWidth - 20 + "px"
          : left + (targetCompWidth + 20) + "px";
    }
    // eslint-disable-next-line
  }, [currentStep]);

  return (
    <div className={styles.toolTip} ref={ref}>
      <h4>{title}</h4>
      <p>{content}</p>
      <div className={styles.action}>
        {next && (
          <Button
            onClick={handleNext}
            variant="primary-partner-white"
            btnText="Next"
          />
        )}
        {!next && (
          <Button
            onClick={handleOk}
            variant="primary-partner-white"
            btnText="Got it"
          />
        )}
        {toolTips.length > 1 && (
          <span>{`${currentStep + 1}/${toolTips.length}`}</span>
        )}
        <span className={styles.arrow} style={getArrowStyles()}></span>
      </div>
    </div>
  );
};

export default ToolTipCard;
